import { flatten, uniqBy } from "lodash"
import { useEffect, useState } from "react"
import { Query } from "../../../../utilities/incognitaAPI"

export const GET_OPTIONS = `
  query dataProtectionOptions(
    $type: String!
  ) {
    dataProtectionOptions(
      type: $type
    ) {
      value
      label
    }
  }
`

const useOptions = (customers) => {
  const customerOptions = customers.map(customer => (
    { label: customer.name, value: customer.id }
  ))

  const storagePolicyOptions = flatten(customers.map(customer => (
    (customer.storage_policies.map(storagePolicy => (
      { label: storagePolicy.name, value: storagePolicy.id }
    )))
  )))
  
  const locationOptions = uniqBy(flatten(customers.map(customer => (
    (customer.storage_policies.map(storagePolicy => (
      { label: storagePolicy.location.name, value: storagePolicy.location.id }
    )))
  ))), 'value')
  
  const commcellOptions = uniqBy(flatten(customers.map(customer => (
    (customer.storage_policies.map(storagePolicy => (
      { label: storagePolicy.commcell.name, value: storagePolicy.commcell.id }
    )))
  ))), 'value')

  const outOfScheduleOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false}
  ]

  const [options, setOptions] = useState({
    customers: customerOptions,
    storagePolicies: storagePolicyOptions,
    locations: locationOptions,
    commcells: commcellOptions,
    subclients: [],
    jobTypes: [],
    statuses: [],
    outOfSchedule: outOfScheduleOptions
  })

  const [loading, setLoading] = useState({
    subclient: true,
    jobType: true,
    status: true
  })

  useEffect(() => {
    getDynamicOptions()
  }, [])

  const getDynamicOptions = () => {
    Query(GET_OPTIONS, { type: 'subclient' })
      .then(({ dataProtectionOptions: options }) => setOptions(state => ({ ...state, subclients: options })))
      .finally(() => setLoading(state => ({...state, subclient: false})))
  
    Query(GET_OPTIONS, { type: 'job_type' })
      .then(({ dataProtectionOptions: options }) => setOptions(state => ({ ...state, jobTypes: options })))
      .finally(() => setLoading(state => ({...state, jobType: false})))
  
    Query(GET_OPTIONS, { type: 'status' })
      .then(({ dataProtectionOptions: options }) => setOptions(state => ({ ...state, statuses: options })))
      .finally(() => setLoading(state => ({...state, status: false })))
  }

  return {
    loading,
    options
  }
}

export default useOptions
